const MunRegistration = () =>{
  return<div>MUN Registration</div>
};
export default MunRegistration;
